var map = {
	"./imgFive.jpg": 901,
	"./imgFour.jpg": 970,
	"./imgTree.jpg": 157,
	"./imgseven.jpg": 6,
	"./imgsex.jpg": 292,
	"./imgtow.jpg": 16
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 685;